import React, { useState, useEffect } from 'react'
import { Modal, Input, Empty, InputRef } from 'antd'
import { Search } from 'lucide-react'
import { SearchResults } from './SearchResults'
import { useKeyboardShortcut } from '../../hooks/useKeyboardShortcut'
import { useGoBar } from './useGoBar'

export const GoBar = ({
  open,
  setOpen
}: {
  open: boolean
  setOpen: (value: boolean) => void
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const { results, selectedIndex, handleSelect, handleKeyNavigation } =
    useGoBar(searchTerm)

  const inputRef = React.useRef<InputRef>(null)

  // Register keyboard shortcut
  useKeyboardShortcut('/', (e) => {
    // Prevent triggering if user is typing in an input
    if (
      e.target instanceof HTMLInputElement ||
      e.target instanceof HTMLTextAreaElement ||
      (e.target instanceof HTMLElement && e.target.contentEditable == 'true')
    ) {
      return
    }
    e.preventDefault()
    setOpen(true)
  })

  // Reset state when closing
  useEffect(() => {
    setTimeout(() => {
      inputRef.current?.focus()
    }, 50)
    if (!open) {
      setSearchTerm('')
    }
  }, [open])

  return (
    <>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={600}
        className="go-bar-modal"
        styles={{
          body: { padding: 0 },
          mask: { backdropFilter: 'blur(4px)' }
        }}
      >
        <div className="p-4 border-b">
          <Input
            ref={inputRef}
            prefix={<Search className="h-4 w-4 text-gray-400" />}
            placeholder="Search for line items or groups..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => handleKeyNavigation(e, () => setOpen(false))}
            className="text-lg"
          />
        </div>

        <div className="max-h-[60vh] overflow-y-auto">
          {results.length > 0 ? (
            <SearchResults
              results={results}
              selectedIndex={selectedIndex}
              onSelect={(result) => {
                handleSelect(result)
                setOpen(false)
              }}
            />
          ) : (
            searchTerm && (
              <Empty className="py-12" description="No matching items found" />
            )
          )}
        </div>

        <div className="p-3 border-t bg-gray-50 text-xs text-gray-500">
          <div className="flex justify-between">
            <div>
              <span className="px-1.5 py-0.5 bg-white border rounded">↑</span>
              <span className="px-1.5 py-0.5 bg-white border rounded ml-1">
                ↓
              </span>
              <span className="ml-2">to navigate</span>
            </div>
            <div>
              <span className="px-1.5 py-0.5 bg-white border rounded">
                enter
              </span>
              <span className="ml-2">to select</span>
            </div>
            <div>
              <span className="px-1.5 py-0.5 bg-white border rounded">esc</span>
              <span className="ml-2">to close</span>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
